<template>
  <svg viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 13L1 7L7 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
